<template>
  <div class="orderHistory" :style="`padding-top:${couponCardHeight}px`">
    <div class="top-block" id="top-block"  v-if="!isScannerOpen && !$route.query.showLocalShop">
      <div class="verify-shop-info flx" v-if="isTab && shopQrDetail && shopQrDetail.length > 0 && shopQrDetail[0].sellerLiteDTO &&shopQrDetail[0].sellerLiteDTO.documentStatus === 'UNVERIFIED'">
        <i class="material-icons">info</i>
        <p class="info-msg">{{$t('yourShopHasNotVerified')}}</p>
        <button type="button" class="verify-shop-btn" @click="isVerificationFormPopup = !isVerificationFormPopup" style="text-transform:capitalize;white-space: nowrap;">Under Verification</button>
      </div>
      <div class="verify-shop-info flx" v-else-if="isTab && shopQrDetail && shopQrDetail.length > 0 && shopQrDetail[0].sellerLiteDTO &&shopQrDetail[0].sellerLiteDTO.documentStatus === 'REJECTED'">
        <i class="material-icons">info</i>
        <p class="info-msg">{{$t('shopRejectedTryAgain')}}</p>
        <button type="button" class="verify-shop-btn" @click="isVerificationFormPopup = !isVerificationFormPopup" style="white-space: nowrap;">Verify shop</button>
      </div>
      <div class="verify-shop-info flx" v-else-if="isTab && shopQrDetail && shopQrDetail.length > 0 && shopQrDetail[0].sellerLiteDTO &&shopQrDetail[0].sellerLiteDTO.documentStatus != 'VERIFIED'">
        <i class="material-icons">info</i>
        <p class="info-msg">{{$t('yourShopHasNotVerified')}}</p>
        <button type="button" class="verify-shop-btn" @click="isVerificationFormPopup = !isVerificationFormPopup">Verify Shop</button>
      </div>
      <header v-if="isTab" class="flx" style="height: 88px;">
        <!-- <h4>{{ $t('dashBoard') }}</h4> -->
          <div class="shopqr-detail" v-if="shopQrDetail && shopQrDetail.length > 0 && shopQrDetail[0].sellerLiteDTO" @click="getQRCode('my_qrcode')">
            <div class="shop-image">
            <img :src="shopQrDetail[0].sellerLiteDTO.shopImage" />
            </div>
            <div class="shop-detail">
              <p class="shop-name">{{shopQrDetail[0].sellerLiteDTO.storeName}}</p>
              <p class="address"> <span class="material-icons" style="font-size: 1.25em">location_on</span> {{
          shopQrDetail[0].sellerLiteDTO.sellerShopAddress.address +
          " " +
          shopQrDetail[0].sellerLiteDTO.sellerShopAddress.city+ ' ' +
          shopQrDetail[0].sellerLiteDTO.sellerShopAddress.zipCode
        }}</p>
            </div>

          </div>
        <!-- <span class="support-icon"> -->
          <a href="tel:011-431-48949" class="support-icon">
          <support-icon />
          </a>
          <span class="setting-icon" @click="goToSetting(shopQrDetail[0].sellerLiteDTO.storeName)" style="margin-left:8px" v-if="$route.query.shopid">
            <setting-icon />
          </span>
        <!-- </span> -->
      </header>
    <div class="shop-share" v-if="shopQrDetail && shopQrDetail.length > 0 && shopQrDetail[0].sellerLiteDTO">
      <p class="shop-link">
        Your Shop Link <br />
        <span>{{shopQrDetail[0].sellerLiteDTO.shopLink}}</span>
      </p>
      <span class="share-btn" @click="shopShare(shopQrDetail[0].sellerLiteDTO.shopShareMessage)">Share</span>
    </div>
    <div class="shop-detail" v-if="!isScannerOpen && isTab">
      <ul class="orders-tab">
      <!-- <li class="orders-tab" :class="{'active' : orderStatus === 'my_localshop'}" v-if="$route.query.showLocalShop === 'true'">
          <input
            type="radio"
            id="test5"
            name="radio-group"
            value="my_localshop"
            v-model="orderStatus"
            @change="changeStatus('my_localshop')"
          />
          <label for="test5">{{$t('myShops')}}</label>
        </li> -->
        <li class="orders-tab" :class="{'active' : orderStatus === 'myshop_order'}">
          <input
            type="radio"
            id="test2"
            name="radio-group"
            value="myshop_order"
            v-model="orderStatus"
            @change="changeStatus('myshop_order')"
          />
          <label for="test2">{{$t('orders')}}</label>
        </li>
        <li class="orders-tab last" :class="{'active' : orderStatus === 'my_products'}">
          <input
            type="radio"
            id="test1"
            name="radio-group"
            value="my_products"
            v-model="orderStatus"
            @change="changeStatus('my_products')"
          />
          <label for="test1">{{$t('products')}}</label>
        </li>
        <li class="orders-tab" :class="{'active' : orderStatus === 'my_payments'}">
          <input
            type="radio"
            id="test3"
            name="radio-group"
            value="my_payments"
            v-model="orderStatus"
            @change="changeStatus('my_payments')"
          />
          <label for="test3">{{$t('payments')}} </label>
        </li>
        
        <li class="orders-tab" :class="{'active' : orderStatus === 'my_qrcode'}" v-if="shopQrDetail && shopQrDetail.length > 0 && shopQrDetail[0].sellerLiteDTO">
          <input
            type="radio"
            id="test4"
            name="radio-group"
            value="my_qrcode"
            v-model="orderStatus"
            @change="changeStatus('my_qrcode')"
          />
          <label for="test4">{{$t('qrCode')}}</label>
        </li>
        
        
      </ul>      
    </div>
    </div>
    <!-- <div class="localshop-header">
      ghbbh
    </div> -->

    <div class="shop-detail" v-if="$route.query.showLocalShop" style="position: fixed;bottom: 0;background: #fff;top: auto;box-shadow:0 -4px 12px 0 rgb(0 0 0 / 15%)">
    <ul class="orders-tab with-ads" v-if="$route.query.showLocalShop === 'true'">
      <li class="orders-tab" :class="{'active' : orderStatus === 'my_ads'}">
      <label for="test7">
          <img src="../assets/images/icons/ads-active-icon.png" v-if="orderStatus === 'my_ads'"/>
          <img src="../assets/images/icons/ads-icon.png" v-else/>
          <input
            type="radio"
            id="test7"
            name="radio-group"
            value="my_ads"
            v-model="orderStatus"
            @change="changeStatus('my_ads')"
          />
          <p>आपके विज्ञापन</p></label>
        </li>
        <li class="orders-tab" :class="{'active' : orderStatus === 'my_localshop'}">
        <label for="test6">
          <img src="../assets/images/icons/shop-active-icon.png" v-if="orderStatus === 'my_localshop'"/>
          <img src="../assets/images/icons/shop-icon.png" v-else/>
          <input
            type="radio"
            id="test6"
            name="radio-group"
            value="my_localshop"
            v-model="orderStatus"
            @change="changeStatus('my_localshop')"
          />
          <p>{{$t('myShops')}}</p></label>
        </li>
        
        <li class="orders-tab last" :class="{'active' : orderStatus === 'my_wallet'}">
        <label for="test8">
          <img src="../assets/images/icons/wallet-active-icon.png" v-if="orderStatus === 'my_wallet'"/>
          <img src="../assets/images/icons/wallet-icon.png" v-else/>
          <input
            type="radio"
            id="test8"
            name="radio-group"
            value="my_wallet"
            v-model="orderStatus"
            @change="changeStatus('my_wallet')"
          />
          <p>वॉलेट</p></label>
        </li>
        
      </ul>
    </div>
    <div class="scantab-ftr" v-if="orderStatus === 'myshop_order' && !isScannerOpen" >
      <div class="scan-tab">
        <span class="scan-elm" @click="openScanner()">
          <scan-icon />
          <span class="text-label">{{$t('scanQrCode')}}</span>
        </span>
      </div>
    </div>
    <div class="scantab-ftr" v-if="orderStatus === 'myshop_order' && ['a684eceee76fc522773286a895bc8436'].includes($cookie.get('X-Auth-Id'))" style="bottom:84px">
      <div class="scan-tab">
        <span class="scan-elm" @click="openScannerViaJsBridge()">
          <scan-icon />
          <span class="text-label">Scan QR CODE Via JSBridgePlugin</span>
        </span>
      </div>
    </div>
    <MyOrders v-if="orderStatus === 'myshop_order'" :couponCardHeight='couponCardHeight' />

    <MyProducts
      @openAddProductOptionModal="
        openAddProductOptionModal = !openAddProductOptionModal
      "
      v-if="orderStatus === 'my_products'"
      @productListLength='checkProductListLength'
      :isActiveMallSupply='activeMallSupply'
      :couponCardHeight='couponCardHeight'
    />
    <MyPayments v-if="orderStatus === 'my_payments'" :couponCardHeight='couponCardHeight' />
    <MyQrCode v-if="orderStatus === 'my_qrcode' && shopQrDetail && shopQrDetail.length > 0 && shopQrDetail[0].sellerLiteDTO" :getshopQrDetails='shopQrDetail' @getLinkedQr="getShopQrDetail" :couponCardHeight='couponCardHeight' />
    <MyLocalShops v-if="orderStatus === 'my_localshop' "/>
    <AdsListing v-if="orderStatus === 'my_ads'" />
    <WalletHistory v-if="orderStatus === 'my_wallet'" />
    <VerificationForm v-if="isVerificationFormPopup || $route.query.verificationShop==='verify'" :getShopQrDetail='shopQrDetail' @closeVerificationForm="closeVerificationPopup" @callAgainShopQr='getShopQrDetail' />
    <Scanner
      v-if="isScannerOpen"
      :isGlobalScanner="true"
      @orderId="getOrderId"
      @closeScanner="isScannerOpen = !isScannerOpen"
    />
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
  <div class="cntntLoad" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
    <AddProductOptionModal
      @closeAddProductOptionModal="openAddProductOptionModal = false"
      :openAddProductOptionModal="openAddProductOptionModal"
      :isProductListLength='isListLength'
    />
  </div>
</template>

<script>
import '../assets/css/order-history.scss';
import '../assets/css/scratch-card.scss';
import ScanIcon from '../components/Icons/ScanIcon';
import MyOrders from '../components/OrderHistorySection/MyOrders';
import MyProducts from '../components/OrderHistorySection/MyProducts';
import MyPayments from '../components/OrderHistorySection/MyPayments';
import MyQrCode from '../components/OrderHistorySection/MyQrCode';
import MyLocalShops from '../components/OrderHistorySection/MyLocalShops';
import AdsListing from '../pages/AdsListing';
import WalletHistory from '../pages/WalletHistory';
import { mapGetters,mapMutations } from 'vuex';
import { navigatePartnerByOrderStatus } from '../utils/helper';
import ApiCaller from '../utils/apicaller';
import constant from '../utils/constant';
import CustomToaster from '../components/Common/CustomToaster';
import AddProductOptionModal from '../components/OrderHistorySection/AddProductOptionModal';
import { getMediaPermission } from "../utils/helper";
import SupportIcon from '../components/Icons/SupportIcon.vue';
import SettingIcon from '../components/Icons/SettingIcon.vue';
import VerificationForm from '../components/ShopManagementSection/VerificationForm'
export default {
  name: 'OrderHistory',
  beforeCreate(){
    if(this.$route.query.isScanner === 'scan'){
      this.isScannerOpen = true
    }else{
      this.isScannerOpen = false
    }
  },
  components: {
    Scanner: () => import('../components/Scanner'),
    MyProducts,
    MyOrders,
    MyPayments,
    MyQrCode,
    MyLocalShops,
    ScanIcon,
    CustomToaster,
    AddProductOptionModal,
    SupportIcon,
    SettingIcon,
    VerificationForm,
    AdsListing,
    WalletHistory
  },
  computed: {
    ...mapGetters(['cartSize', 'userInfo']),
  },
  data() {
    return {
      orderStatus: null,
      activeMallSupply: false,
      isActive: false,
      isScannerOpen: false,
      toasterData: {},
      isToasterData: false,
      openAddProductOptionModal: false,
      isListLength: false,
      isTab: true,
      shopQrDetail: [],
      loading: false,
      isVerificationFormPopup: false,
      couponCardHeight: '',
    };
  },
  
  methods: {
    ...mapMutations(['saveUserShopId']),
    openScanner(){
      this.isScannerOpen = !this.isScannerOpen
    },
    closeVerificationPopup(){
      if(this.$route.query.verificationShop){
        this.$router.go(-1)
      }else{
        this.isVerificationFormPopup=!this.isVerificationFormPopup
      }
    },
    shopShare(shareMessage){
      const obj = {
        message: shareMessage
      };
      try {
        JSBridgePlugin.share(JSON.stringify(obj));
      } catch (err) {
        console.log(err);
        window.open("whatsapp://send?text=" + shareMessage);
      }
    },
    openScannerViaJsBridge(){
      try {
        _getScanner.openNativeScanner = res => {
          this.loading = false
          console.log(res)
          if(res){
            this.getOrderId(Number(res));
          }
        };
        JSBridgePlugin.openNativeScanner("_getScanner.openNativeScanner");
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    goToSetting(storeName){
      if(this.$route.query.CLOUDSHOP){
        this.$router.push('/shop-management?shopid='+ this.$route.query.shopid + '&shopName='+storeName + '&CLOUDSHOP=YES')
      }else{
        this.$router.push('/shop-management?shopid='+ this.$route.query.shopid + '&shopName='+storeName)
      }
    },
    checkProductListLength(value){
      this.isListLength = value
    },
    openSearch() {
      var element = document.getElementById('contn');
      element.classList.add('show');
    },
    closeSearch() {
      var element = document.getElementById('contn');
      element.classList.remove('show');
    },
    getQRCode(order_status){
      this.orderStatus = "my_qrcode";
      this.$cookie.set("orderStatus", order_status);
    },
    changeStatus(order_status) {
      // if(order_status === 'my_ads'){
      //   this.$router.push('/dashboard')
      // }
      this.$cookie.set("orderStatus", order_status);
    },
    getOrderId(_orderId) {
      this._orderId = _orderId;
      this.isLoading = !this.isLoading;
      let _this = this;
      ApiCaller(constant.LOCAL_SHOP_URL_ORDER,
        "get-order-by-qrcode/" + _orderId,
        "get"
      )
        .then((data) => {
          this.isLoading = !this.isLoading;
          this.isScannerOpen = false;
          if(data.data.subOrderDTOList && data.data.subOrderDTOList.length){
            this.$router.push('/order-by-suborder/?qrCode=' + _orderId)
          }else{
            this.toasterData = {
              msg: 'No Data Found',
              color: "#e51c24",
              iconName: "close",
            };
            this.isToasterData = true;
            return false;
          }

        })
        .catch(err => {
          this.isLoading = !this.isLoading;
          this.isScannerOpen = false;
          console.log(err)
          if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getOrderId(_orderId);
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }else{
              if(err.response.data.message){
                  this.toasterData = {
                  msg: err.response.data.message,
                  color: "#e51c24",
                  iconName: "close",
                };
                this.isToasterData = true;
                return false;
              }else{
                this.toasterData = {
                  msg: 'Invalid QR code',
                  color: "#e51c24",
                  iconName: "close",
                };
                this.isToasterData = true;
                return false;
              }

            }
        });
    },
    getShopQrDetail() {
      if (this.$cookie.get("X-Auth-Id") != null) {
        this.loading = true
        let payloadObject;
          if(this.$route.query.shopid){
            payloadObject = `get-seller-shop-qr?shopid=${this.$route.query.shopid}`
          }else{
            payloadObject = 'get-seller-shop-qr'
          }
        ApiCaller(constant.SELLER_DETAIL_URL, payloadObject, "get")
          .then((data) => {
            this.shopQrDetail = data.data;
            this.loading = false;
            var elmnt = document.getElementById("top-block");
                if(elmnt){
                  if(this.$route.query.showLocalShop){
                    this.couponCardHeight = elmnt.offsetHeight
                  }else{
                    this.couponCardHeight = elmnt.offsetHeight
                  }
                  
                  console.log(elmnt.offsetHeight)
                }
          })
          .catch((err) => {
            this.loading = false;
            if (
              err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
              err.response.data.message ==
                "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
            ) {
              try {
                _JWT.refereshToken = (res) => {
                  if (res != "fail") {
                    this.$cookie.set("JWT-TOKEN", res);
                    this.getShopQrDetail();
                  } else {
                    this.loading = false;
                  }
                };
                JSBridgePlugin.refreshTokens("_JWT.refereshToken");
              } catch (err) {
                this.loading = false;
                console.log(err);
              }
            }else{
              console.log(err)
            }
          });
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
  },
  mounted() {
    this.getShopQrDetail();
    
    if(this.$route.query.shopid) this.saveUserShopId(this.$route.query.shopid);
    if(this.$route.query.isScanner === 'scan'){
      this.isScannerOpen = true
    }else{
      this.isScannerOpen = false
    }
    if (this.$cookie.get('X-Auth-Id') != null) {
      // if(!this.$route.query.showLocalShop || this.$route.query.showLocalShop=== 'false'){
      //   this.$cookie.set("orderStatus", 'myshop_order');
      //   this.orderStatus = 'myshop_order'
      // }
      if(this.$route.query.showLocalShop){  
           if(this.$cookie.get('orderStatus')==='myshop_order' || this.$cookie.get('orderStatus')==='my_products'){
             this.$cookie.delete('orderStatus')
           }
        if(this.$cookie.get('orderStatus')){  
          // this.$cookie.delete('orderStatus')         
          this.orderStatus = this.$cookie.get('orderStatus')
        }else{          
          this.$cookie.set("orderStatus", 'my_ads');
          this.orderStatus = 'my_ads'
        }
      }
      // this.orderStatus = this.$cookie.get("orderStatus");
      // if (this.orderStatus == null) {
      //   this.orderStatus = "myshop_order";
      // }
      
      else if(this.$route.query.tab){
        this.isTab = false;
        if(this.$route.query.tab == 'myShop'){
          this.orderStatus = "myshop_order";
        }else if(this.$route.query.tab == 'myProduct'){
          this.orderStatus = "my_products";
        }else if(this.$route.query.tab == 'myPayments'){
          this.orderStatus = "my_payments";
        }else if(this.$route.query.tab == 'myQrCode'){
          this.orderStatus = "my_qrcode";
        }else if(this.$route.query.tab == 'my_localshop'){
          this.orderStatus = "my_localshop";
        }
      }else if(this.$route.query.openTab == 'myProduct'){
          this.orderStatus = "my_products";
          // this.activeMallSupply = true
        }else{
          console.log(this.$cookie.get('orderStatus'))
          this.$cookie.set("orderStatus", 'myshop_order');
          this.orderStatus = 'myshop_order'
          this.orderStatus = this.$cookie.get('orderStatus')
        }

    } else {
      try {
        _prompt_login.promptLogin = (res) => {
          if (res == 'success') {
            console.log(res);
          } else {
            this.loading = false;
          }
        };
        JSBridgePlugin.promptLogin('_prompt_login.promptLogin');
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.verify-shop-info{
  background: #FA6400;
  color: #fff;
    padding: 8px;
    .info-msg{
      padding: 0 16px;
      font-size:0.875em;
    }
    .verify-shop-btn{
          background: #fff;
    border: 0;
    border-radius: 4px;
    width: 40%;
    padding: 11px 8px;
    text-transform: uppercase;
    font-size: 0.75em;
    font-weight: 600;
    }
}
.support-icon{
  svg{
    fill: #505050;
  }
}
.orderHistory .top-block header .shopqr-detail .shop-detail .address{
      height: 30px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>